<script setup>
import { ref, watch, computed } from "vue";
import TooltipIcon from "./TooltipIcon.vue";

defineOptions({
    inheritAttrs: false,
});

const input = ref(null);

const props = defineProps({
    modelValue: null,
    required: {
        type: Boolean,
    },
    errors: {
        type: Object,
        default: {},
    },
    suffixIcon: {
        type: String,
        default: "",
    },
    suffixTooltip: {
        type: String,
        default: "",
    },
    showErrorIcon: {
        type: Boolean,
        default: true,
    },
    hasTooltip: {
        type: Boolean,
        default: false,
    },
    tooltipText: {
        type: String,
        default: "",
    },
});

defineEmits(["update:modelValue"]);

const hasError = computed(() => props.errors && props.errors.$error);

watch(
    () => props.modelValue,
    (value) => {
        if (value) {
            input.value.parentElement.classList.add("is-filled");
        }
    }
);

// when input is focused add focused class for style
function focused(evt) {
    if (evt.target.parentElement.classList.contains("input-group")) {
        evt.target.parentElement.classList.add("focused");
        evt.target.parentElement.classList.add("is-focused");
    }
}

// when input is focused remove focused class for style
function defocused(evt) {
    if (evt.target.parentElement.classList.contains("input-group")) {
        if (evt.target.value != "") {
            evt.target.parentElement.classList.add("is-filled");
        }
        evt.target.parentElement.classList.remove("focused");
        evt.target.parentElement.classList.remove("is-focused");
    }
}

function keyupHandler(evt) {
    if (evt.target.value != "") {
        return evt.target.parentElement.classList.add("is-filled");
    }

    return evt.target.parentElement.classList.remove("is-filled");
}
</script>

<template>
    <div class="form-group mb-1">
        <label v-if="$attrs.label" :for="$attrs.id" class="form-label"
            >{{ $attrs.label }}
            <span v-if="required" class="text-black astric">*</span>
        </label>

        <div class="input-with-icon" :class="{ 'has-error': hasError }">
            <textarea
                :id="$attrs.id"
                ref="input"
                :disabled="$attrs.disabled"
                :name="$attrs.name"
                :placeholder="$attrs.placeholder || ''"
                :readonly="$attrs.readonly"
                :rows="$attrs.rows || 3"
                :value="modelValue"
                class="form-control"
                :class="{ 'is-invalid': hasError }"
                v-bind="$attrs"
                @focus="focused"
                @focusout="defocused"
                @input="$emit('update:modelValue', $event.target.value)"
                @keyup="keyupHandler"
            ></textarea>
            <template v-if="hasTooltip">
                <TooltipIcon :content="tooltipText" />
            </template>

          <!-- <span
                v-if="hasError && showErrorIcon"
                class="suffix-icon error-icon"
                :title="errors?.$errors?.[0]?.$message || ''"
            >
                
            </span> 
            <span
                v-else-if="suffixIcon"
                class="suffix-icon"
                :title="suffixTooltip"
            >
                <i :class="suffixIcon"></i>
            </span> -->
        </div>

        <small
            v-if="errors.$error"
            class="text-danger"
            style="font-size: 0.8rem; top: 40px"
        >
            {{ errors.$errors[0].$message }}
        </small>
    </div>
</template>

<style scoped>
.input-with-icon {
    position: relative;
}

.input-with-icon .form-control {
    padding-right: 2.25rem;
    border-radius: 0.5rem;
}

/* .suffix-icon {
    position: absolute;
    right: 0.5rem;
    top: 50%;
    transform: translateY(-50%);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    height: 1.5rem;
    color: #6c757d;
}

.suffix-icon i {
    font-size: 1rem;
}

.error-icon {
    background-color: #ffffff;
    border: 2px solid #dc3545;
    color: #dc3545;
    border-radius: 9999px;
    font-weight: 700;
    font-size: 0.9rem;
    line-height: 1rem;
}

.form-control.is-invalid {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.1rem rgba(220, 53, 69, 0.1);
} */

.el-popper {
    margin-top: 2px !important;
    /* reduce gap */
}
</style>
